import * as React from "react";
import { useState, useRef } from "react"; // <== ajoute useRef ici
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import {
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Button,
  Box,
} from "@mui/material";

import { useGetAllBureausQuery } from "../../app/services/bureauApi";
import { useGetCourQuery } from "../../app/services/courApi";
import Loader from "../loader/Loader";
import CoursCard from "./CoursCard";
import ReservationPromo from "./ReservationPromo";
import BusinessIcon from "@mui/icons-material/Business";

export default function CoursBureau() {
  const [bureauId, setBureauId] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");

  const { data, isLoading } = useGetCourQuery(bureauId);
  const { data: bureaus } = useGetAllBureausQuery();

  const coursRef = useRef(null); // <== référence à la section cours

  const handleChangeBureau = (event) => {
    setBureauId(event.target.value);
    setErrorMessage("");
  };

  const scrollToCours = () => {
    if (coursRef.current) {
      const offset = 64; // Ajuste cette valeur selon la hauteur de ta navbar
      const top =
        coursRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  };

  if (isLoading) return <Loader />;

  const members = bureaus?.map((bureau) => (
    <MenuItem key={bureau?.id} value={bureau?.id}>
      <Stack direction="column" spacing={0.5}>
        <Typography variant="subtitle1" fontWeight="bold">
          {bureau?.nom}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {bureau?.quartier}
        </Typography>
      </Stack>
    </MenuItem>
  ));

  return (
    <Stack>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ padding: 2, flexWrap: "wrap" }}
      >
        <Card sx={{ maxWidth: 320, backgroundColor: "#ffeb3b", flex: 1 }}>
          <CardContent>
            {/* ✅ Message à l'utilisateur */}
            <Typography variant="body1" sx={{ mb: 2 }}>
              Veuillez choisir un bureau de change pour consulter ses cours et
              effectuer votre réservation.
            </Typography>

            <Typography variant="h5">
              <SearchIcon /> Recherche
            </Typography>

            <InputLabel id="bureau-label">
              Bureau de change & quartier
            </InputLabel>
            <Select
              labelId="bureau-label"
              id="bureau-select"
              onChange={handleChangeBureau}
              sx={{ minWidth: "100%" }}
            >
              {members}
            </Select>
          </CardContent>

          <CardContent>
            <iframe
              style={{ width: "100%" }}
              src={data?.Bureau?.location}
              height="240"
            ></iframe>
          </CardContent>

          <CardContent>
            <Typography gutterBottom variant="body2">
              <AccessTimeRoundedIcon /> Ouvert de{" "}
              {data?.Bureau?.heure_ouverture} à {data?.Bureau?.heure_fermeture}
            </Typography>
          </CardContent>
        </Card>

        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            maxWidth: 800,
            marginTop: 4,
          }}
        >
          <ReservationPromo />
          <Stack
            direction="row"
            spacing={2}
            sx={{ padding: 2 }}
            justifyContent={"space-between"}
          >
            <Typography gutterBottom variant="h5" color="goldenrod">
              <BusinessIcon /> {data?.Bureau?.nom} - {data?.Bureau?.quartier}
            </Typography>

            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={scrollToCours} // <== déclenche le scroll
            >
              Voir nos cours
            </Button>
          </Stack>

          <CardMedia
            component="img"
            sx={{ width: "100%", height: 280, objectFit: "cover" }}
            // image={`https://exchange-maroc.com/images/bureaux/${data?.Bureau?.image}`}
            image={`${process.env.REACT_APP_BASE_FILE_URL}/bureaux/${data?.Bureau?.image}`}
            alt="AFRICA EXCHANGE"
          />

          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {data?.Bureau?.adresse}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {data?.Bureau?.telephone}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {data?.Bureau?.email}
            </Typography>
          </CardContent>
        </Card>
      </Stack>

      {/* Section des cours avec une ref */}
      <div ref={coursRef}>
        <CoursCard
          cours={data?.Bureau?.cours}
          nomBureau={data?.Bureau?.nom}
          quartierBureau={data?.Bureau?.quartier}
        />
      </div>
    </Stack>
  );
}
